(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["livera-lp-bloating"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.lv').forEach(function(root){
  var main=root.querySelector('#lvGalMain');
  var lvVid=root.querySelector('#lvGalVideo');
  root.querySelectorAll('.lv-thumb').forEach(function(t){
    t.addEventListener('click',function(){
      root.querySelectorAll('.lv-thumb').forEach(function(x){x.classList.remove('is-active')});
      t.classList.add('is-active');
      if(t.dataset.type==='video' && lvVid){
        if(main) main.style.display='none';
        lvVid.style.display='block';
        var s=lvVid.querySelector('source');
        if(s && s.getAttribute('src')!==t.dataset.src){ s.src=t.dataset.src; lvVid.load(); }
        var pp=lvVid.play(); if(pp&&pp.catch) pp.catch(function(){});
      } else {
        if(lvVid){ lvVid.pause(); lvVid.style.display='none'; }
        if(main){ main.style.display='block'; if(t.dataset.src) main.src=t.dataset.src; }
      }
    });
  });
  var lvStage = root.querySelector('.lv-gallery-main');
  if (lvStage) {
    var lsx=0, lsy=0, ltk=false;
    lvStage.addEventListener('touchstart', function(e){ var t=e.changedTouches[0]; lsx=t.clientX; lsy=t.clientY; ltk=true; }, {passive:true});
    lvStage.addEventListener('touchend', function(e){ if(!ltk)return; ltk=false; var t=e.changedTouches[0]; var dx=t.clientX-lsx, dy=t.clientY-lsy; if(Math.abs(dx)>40 && Math.abs(dx)>Math.abs(dy)){ var th=root.querySelectorAll('.lv-thumb'); var cur=0; th.forEach(function(x,i){ if(x.classList.contains('is-active')) cur=i; }); var nx=(cur+(dx<0?1:-1)+th.length)%th.length; th[nx].click(); } }, {passive:true});
  }
  root.querySelectorAll('.lv-offer').forEach(function(o){
    o.addEventListener('click',function(){
      root.querySelectorAll('.lv-offer').forEach(function(x){x.classList.remove('is-selected');var r=x.querySelector('input[type=radio]');if(r)r.checked=false;});
      o.classList.add('is-selected');var r=o.querySelector('input[type=radio]');if(r)r.checked=true;
      var vi=document.getElementById('lvVarInput'),qi=document.getElementById('lvQtyInput'),pi=document.getElementById('lvPlanInput');
      if(vi)vi.value=o.getAttribute('data-variant')||'';
      if(qi)qi.value=o.getAttribute('data-qty')||'1';
      if(pi){var p=o.getAttribute('data-plan')||'';if(p){pi.value=p;pi.disabled=false;}else{pi.value='';pi.disabled=true;}}
    });
  });
});
(function(){
  var trigger=document.querySelector('[data-menu-trigger]');
  var drawer=document.querySelector('[data-menu-drawer]');
  var overlay=document.querySelector('[data-menu-overlay]');
  var closeBtn=document.querySelector('[data-menu-close]');
  if(!trigger||!drawer||!overlay)return;
  function open(){drawer.classList.add('open');overlay.classList.add('open');overlay.removeAttribute('hidden');trigger.setAttribute('aria-expanded','true');drawer.setAttribute('aria-hidden','false');document.documentElement.classList.add('lvh-menu-open');}
  function shut(){drawer.classList.remove('open');overlay.classList.remove('open');trigger.setAttribute('aria-expanded','false');drawer.setAttribute('aria-hidden','true');document.documentElement.classList.remove('lvh-menu-open');setTimeout(function(){overlay.setAttribute('hidden','');},300);}
  trigger.addEventListener('click',open);
  if(closeBtn)closeBtn.addEventListener('click',shut);
  overlay.addEventListener('click',shut);
  document.addEventListener('keydown',function(e){if(e.key==='Escape'&&drawer.classList.contains('open'))shut();});
})();
(function(){
  var form=document.getElementById('lvBuyForm');
  if(!form)return;
  var status=document.getElementById('lvCartStatus');
  var cta=document.getElementById('lvCta');
  var nativeFallback=false;
  form.addEventListener('submit',function(e){
    if(nativeFallback)return;
    e.preventDefault();
    if(cta)cta.disabled=true;
    if(status){status.hidden=false;status.textContent='Adding to cart…';}
    var fd=new FormData(form);
    fetch('/cart/clear.js',{method:'POST',headers:{'Accept':'application/json'}})
      .then(function(){return fetch('/cart/add.js',{method:'POST',body:fd,headers:{'Accept':'application/json'}});})
      .then(function(res){
        if(!res.ok){throw new Error('add failed');}
        if(status){status.textContent='Added! Redirecting…';}
        window.location.href='/checkout';
      })
      .catch(function(){
        if(status){status.textContent='Finishing in cart…';}
        nativeFallback=true;
        form.submit();
      });
  });
})();
(function(){
  document.querySelectorAll('.lv-tcard--video').forEach(function(card){
    var btn=card.querySelector('.lv-ugc-play');
    if(!btn)return;
    btn.addEventListener('click',function(){
      if(card.classList.contains('is-playing'))return;
      var src=card.getAttribute('data-video'); if(!src)return;
      document.querySelectorAll('.lv-tcard--video video').forEach(function(v){v.pause();});
      var v=document.createElement('video');
      v.className='lv-ugc-video'; v.src=src; v.controls=true; v.setAttribute('playsinline','');
      var p=card.querySelector('.lv-ugc-poster'); if(p)p.style.display='none';
      card.appendChild(v); card.classList.add('is-playing'); v.play();
    });
  });
  var row=document.getElementById('lvTestiRow');
  if(row){
    var prev=document.querySelector('[data-testi-prev]');
    var next=document.querySelector('[data-testi-next]');
    function step(d){row.scrollBy({left:d*280,behavior:'smooth'});}
    if(prev)prev.addEventListener('click',function(){step(-1);});
    if(next)next.addEventListener('click',function(){step(1);});
    var down=false,startX=0,startScroll=0,moved=false;
    row.style.cursor='grab';
    row.addEventListener('pointerdown',function(e){if(e.pointerType!=='mouse')return;down=true;moved=false;startX=e.clientX;startScroll=row.scrollLeft;row.setPointerCapture(e.pointerId);row.style.cursor='grabbing';});
    row.addEventListener('pointermove',function(e){if(!down)return;var dx=e.clientX-startX;if(Math.abs(dx)>4)moved=true;row.scrollLeft=startScroll-dx;});
    function endDrag(){if(down){down=false;row.style.cursor='grab';}}
    row.addEventListener('pointerup',endDrag);
    row.addEventListener('pointercancel',endDrag);
    row.addEventListener('click',function(e){if(moved){e.preventDefault();e.stopPropagation();moved=false;}},true);
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["livera-lp-derek"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.lv').forEach(function(root){
  var main=root.querySelector('#lvGalMain');
  var lvVid=root.querySelector('#lvGalVideo');
  root.querySelectorAll('.lv-thumb').forEach(function(t){
    t.addEventListener('click',function(){
      root.querySelectorAll('.lv-thumb').forEach(function(x){x.classList.remove('is-active')});
      t.classList.add('is-active');
      if(t.dataset.type==='video' && lvVid){
        if(main) main.style.display='none';
        lvVid.style.display='block';
        var s=lvVid.querySelector('source');
        if(s && s.getAttribute('src')!==t.dataset.src){ s.src=t.dataset.src; lvVid.load(); }
        var pp=lvVid.play(); if(pp&&pp.catch) pp.catch(function(){});
      } else {
        if(lvVid){ lvVid.pause(); lvVid.style.display='none'; }
        if(main){ main.style.display='block'; if(t.dataset.src) main.src=t.dataset.src; }
      }
    });
  });
  var lvStage = root.querySelector('.lv-gallery-main');
  if (lvStage) {
    var lsx=0, lsy=0, ltk=false;
    lvStage.addEventListener('touchstart', function(e){ var t=e.changedTouches[0]; lsx=t.clientX; lsy=t.clientY; ltk=true; }, {passive:true});
    lvStage.addEventListener('touchend', function(e){ if(!ltk)return; ltk=false; var t=e.changedTouches[0]; var dx=t.clientX-lsx, dy=t.clientY-lsy; if(Math.abs(dx)>40 && Math.abs(dx)>Math.abs(dy)){ var th=root.querySelectorAll('.lv-thumb'); var cur=0; th.forEach(function(x,i){ if(x.classList.contains('is-active')) cur=i; }); var nx=(cur+(dx<0?1:-1)+th.length)%th.length; th[nx].click(); } }, {passive:true});
  }
  root.querySelectorAll('.lv-offer').forEach(function(o){
    o.addEventListener('click',function(){
      root.querySelectorAll('.lv-offer').forEach(function(x){x.classList.remove('is-selected');var r=x.querySelector('input[type=radio]');if(r)r.checked=false;});
      o.classList.add('is-selected');var r=o.querySelector('input[type=radio]');if(r)r.checked=true;
      var vi=document.getElementById('lvVarInput'),qi=document.getElementById('lvQtyInput'),pi=document.getElementById('lvPlanInput');
      if(vi)vi.value=o.getAttribute('data-variant')||'';
      if(qi)qi.value=o.getAttribute('data-qty')||'1';
      if(pi){var p=o.getAttribute('data-plan')||'';if(p){pi.value=p;pi.disabled=false;}else{pi.value='';pi.disabled=true;}}
    });
  });
});
(function(){
  var trigger=document.querySelector('[data-menu-trigger]');
  var drawer=document.querySelector('[data-menu-drawer]');
  var overlay=document.querySelector('[data-menu-overlay]');
  var closeBtn=document.querySelector('[data-menu-close]');
  if(!trigger||!drawer||!overlay)return;
  function open(){drawer.classList.add('open');overlay.classList.add('open');overlay.removeAttribute('hidden');trigger.setAttribute('aria-expanded','true');drawer.setAttribute('aria-hidden','false');document.documentElement.classList.add('lvh-menu-open');}
  function shut(){drawer.classList.remove('open');overlay.classList.remove('open');trigger.setAttribute('aria-expanded','false');drawer.setAttribute('aria-hidden','true');document.documentElement.classList.remove('lvh-menu-open');setTimeout(function(){overlay.setAttribute('hidden','');},300);}
  trigger.addEventListener('click',open);
  if(closeBtn)closeBtn.addEventListener('click',shut);
  overlay.addEventListener('click',shut);
  document.addEventListener('keydown',function(e){if(e.key==='Escape'&&drawer.classList.contains('open'))shut();});
})();
(function(){
  var form=document.getElementById('lvBuyForm');
  if(!form)return;
  var status=document.getElementById('lvCartStatus');
  var cta=document.getElementById('lvCta');
  var nativeFallback=false;
  form.addEventListener('submit',function(e){
    if(nativeFallback)return;
    e.preventDefault();
    if(cta)cta.disabled=true;
    if(status){status.hidden=false;status.textContent='Adding to cart…';}
    var fd=new FormData(form);
    fetch('/cart/clear.js',{method:'POST',headers:{'Accept':'application/json'}})
      .then(function(){return fetch('/cart/add.js',{method:'POST',body:fd,headers:{'Accept':'application/json'}});})
      .then(function(res){
        if(!res.ok){throw new Error('add failed');}
        if(status){status.textContent='Added! Redirecting…';}
        window.location.href='/checkout';
      })
      .catch(function(){
        if(status){status.textContent='Finishing in cart…';}
        nativeFallback=true;
        form.submit();
      });
  });
})();
(function(){
  document.querySelectorAll('.lv-tcard--video').forEach(function(card){
    var btn=card.querySelector('.lv-ugc-play');
    if(!btn)return;
    btn.addEventListener('click',function(){
      if(card.classList.contains('is-playing'))return;
      var src=card.getAttribute('data-video'); if(!src)return;
      document.querySelectorAll('.lv-tcard--video video').forEach(function(v){v.pause();});
      var v=document.createElement('video');
      v.className='lv-ugc-video'; v.src=src; v.controls=true; v.setAttribute('playsinline','');
      var p=card.querySelector('.lv-ugc-poster'); if(p)p.style.display='none';
      card.appendChild(v); card.classList.add('is-playing'); v.play();
    });
  });
  var row=document.getElementById('lvTestiRow');
  if(row){
    var prev=document.querySelector('[data-testi-prev]');
    var next=document.querySelector('[data-testi-next]');
    function step(d){row.scrollBy({left:d*280,behavior:'smooth'});}
    if(prev)prev.addEventListener('click',function(){step(-1);});
    if(next)next.addEventListener('click',function(){step(1);});
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["livera-lp-lauren"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.lv').forEach(function(root){
  var main=root.querySelector('#lvGalMain');
  var lvVid=root.querySelector('#lvGalVideo');
  root.querySelectorAll('.lv-thumb').forEach(function(t){
    t.addEventListener('click',function(){
      root.querySelectorAll('.lv-thumb').forEach(function(x){x.classList.remove('is-active')});
      t.classList.add('is-active');
      if(t.dataset.type==='video' && lvVid){
        if(main) main.style.display='none';
        lvVid.style.display='block';
        var s=lvVid.querySelector('source');
        if(s && s.getAttribute('src')!==t.dataset.src){ s.src=t.dataset.src; lvVid.load(); }
        var pp=lvVid.play(); if(pp&&pp.catch) pp.catch(function(){});
      } else {
        if(lvVid){ lvVid.pause(); lvVid.style.display='none'; }
        if(main){ main.style.display='block'; if(t.dataset.src) main.src=t.dataset.src; }
      }
    });
  });
  var lvStage = root.querySelector('.lv-gallery-main');
  if (lvStage) {
    var lsx=0, lsy=0, ltk=false;
    lvStage.addEventListener('touchstart', function(e){ var t=e.changedTouches[0]; lsx=t.clientX; lsy=t.clientY; ltk=true; }, {passive:true});
    lvStage.addEventListener('touchend', function(e){ if(!ltk)return; ltk=false; var t=e.changedTouches[0]; var dx=t.clientX-lsx, dy=t.clientY-lsy; if(Math.abs(dx)>40 && Math.abs(dx)>Math.abs(dy)){ var th=root.querySelectorAll('.lv-thumb'); var cur=0; th.forEach(function(x,i){ if(x.classList.contains('is-active')) cur=i; }); var nx=(cur+(dx<0?1:-1)+th.length)%th.length; th[nx].click(); } }, {passive:true});
  }
  root.querySelectorAll('.lv-offer').forEach(function(o){
    o.addEventListener('click',function(){
      root.querySelectorAll('.lv-offer').forEach(function(x){x.classList.remove('is-selected');var r=x.querySelector('input[type=radio]');if(r)r.checked=false;});
      o.classList.add('is-selected');var r=o.querySelector('input[type=radio]');if(r)r.checked=true;
      var vi=document.getElementById('lvVarInput'),qi=document.getElementById('lvQtyInput'),pi=document.getElementById('lvPlanInput');
      if(vi)vi.value=o.getAttribute('data-variant')||'';
      if(qi)qi.value=o.getAttribute('data-qty')||'1';
      if(pi){var p=o.getAttribute('data-plan')||'';if(p){pi.value=p;pi.disabled=false;}else{pi.value='';pi.disabled=true;}}
    });
  });
});
(function(){
  var trigger=document.querySelector('[data-menu-trigger]');
  var drawer=document.querySelector('[data-menu-drawer]');
  var overlay=document.querySelector('[data-menu-overlay]');
  var closeBtn=document.querySelector('[data-menu-close]');
  if(!trigger||!drawer||!overlay)return;
  function open(){drawer.classList.add('open');overlay.classList.add('open');overlay.removeAttribute('hidden');trigger.setAttribute('aria-expanded','true');drawer.setAttribute('aria-hidden','false');document.documentElement.classList.add('lvh-menu-open');}
  function shut(){drawer.classList.remove('open');overlay.classList.remove('open');trigger.setAttribute('aria-expanded','false');drawer.setAttribute('aria-hidden','true');document.documentElement.classList.remove('lvh-menu-open');setTimeout(function(){overlay.setAttribute('hidden','');},300);}
  trigger.addEventListener('click',open);
  if(closeBtn)closeBtn.addEventListener('click',shut);
  overlay.addEventListener('click',shut);
  document.addEventListener('keydown',function(e){if(e.key==='Escape'&&drawer.classList.contains('open'))shut();});
})();
(function(){
  var form=document.getElementById('lvBuyForm');
  if(!form)return;
  var status=document.getElementById('lvCartStatus');
  var cta=document.getElementById('lvCta');
  var nativeFallback=false;
  form.addEventListener('submit',function(e){
    if(nativeFallback)return;
    e.preventDefault();
    if(cta)cta.disabled=true;
    if(status){status.hidden=false;status.textContent='Adding to cart…';}
    var fd=new FormData(form);
    fetch('/cart/clear.js',{method:'POST',headers:{'Accept':'application/json'}})
      .then(function(){return fetch('/cart/add.js',{method:'POST',body:fd,headers:{'Accept':'application/json'}});})
      .then(function(res){
        if(!res.ok){throw new Error('add failed');}
        if(status){status.textContent='Added! Redirecting…';}
        window.location.href='/checkout';
      })
      .catch(function(){
        if(status){status.textContent='Finishing in cart…';}
        nativeFallback=true;
        form.submit();
      });
  });
})();
(function(){
  document.querySelectorAll('.lv-tcard--video').forEach(function(card){
    var btn=card.querySelector('.lv-ugc-play');
    if(!btn)return;
    btn.addEventListener('click',function(){
      if(card.classList.contains('is-playing'))return;
      var src=card.getAttribute('data-video'); if(!src)return;
      document.querySelectorAll('.lv-tcard--video video').forEach(function(v){v.pause();});
      var v=document.createElement('video');
      v.className='lv-ugc-video'; v.src=src; v.controls=true; v.setAttribute('playsinline','');
      var p=card.querySelector('.lv-ugc-poster'); if(p)p.style.display='none';
      card.appendChild(v); card.classList.add('is-playing'); v.play();
    });
  });
  var row=document.getElementById('lvTestiRow');
  if(row){
    var prev=document.querySelector('[data-testi-prev]');
    var next=document.querySelector('[data-testi-next]');
    function step(d){row.scrollBy({left:d*280,behavior:'smooth'});}
    if(prev)prev.addEventListener('click',function(){step(-1);});
    if(next)next.addEventListener('click',function(){step(1);});
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["livera-lp-marcus"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.lv').forEach(function(root){
  var main=root.querySelector('#lvGalMain');
  var lvVid=root.querySelector('#lvGalVideo');
  root.querySelectorAll('.lv-thumb').forEach(function(t){
    t.addEventListener('click',function(){
      root.querySelectorAll('.lv-thumb').forEach(function(x){x.classList.remove('is-active')});
      t.classList.add('is-active');
      if(t.dataset.type==='video' && lvVid){
        if(main) main.style.display='none';
        lvVid.style.display='block';
        var s=lvVid.querySelector('source');
        if(s && s.getAttribute('src')!==t.dataset.src){ s.src=t.dataset.src; lvVid.load(); }
        var pp=lvVid.play(); if(pp&&pp.catch) pp.catch(function(){});
      } else {
        if(lvVid){ lvVid.pause(); lvVid.style.display='none'; }
        if(main){ main.style.display='block'; if(t.dataset.src) main.src=t.dataset.src; }
      }
    });
  });
  var lvStage = root.querySelector('.lv-gallery-main');
  if (lvStage) {
    var lsx=0, lsy=0, ltk=false;
    lvStage.addEventListener('touchstart', function(e){ var t=e.changedTouches[0]; lsx=t.clientX; lsy=t.clientY; ltk=true; }, {passive:true});
    lvStage.addEventListener('touchend', function(e){ if(!ltk)return; ltk=false; var t=e.changedTouches[0]; var dx=t.clientX-lsx, dy=t.clientY-lsy; if(Math.abs(dx)>40 && Math.abs(dx)>Math.abs(dy)){ var th=root.querySelectorAll('.lv-thumb'); var cur=0; th.forEach(function(x,i){ if(x.classList.contains('is-active')) cur=i; }); var nx=(cur+(dx<0?1:-1)+th.length)%th.length; th[nx].click(); } }, {passive:true});
  }
  root.querySelectorAll('.lv-offer').forEach(function(o){
    o.addEventListener('click',function(){
      root.querySelectorAll('.lv-offer').forEach(function(x){x.classList.remove('is-selected');var r=x.querySelector('input[type=radio]');if(r)r.checked=false;});
      o.classList.add('is-selected');var r=o.querySelector('input[type=radio]');if(r)r.checked=true;
      var vi=document.getElementById('lvVarInput'),qi=document.getElementById('lvQtyInput'),pi=document.getElementById('lvPlanInput');
      if(vi)vi.value=o.getAttribute('data-variant')||'';
      if(qi)qi.value=o.getAttribute('data-qty')||'1';
      if(pi){var p=o.getAttribute('data-plan')||'';if(p){pi.value=p;pi.disabled=false;}else{pi.value='';pi.disabled=true;}}
    });
  });
});
(function(){
  var trigger=document.querySelector('[data-menu-trigger]');
  var drawer=document.querySelector('[data-menu-drawer]');
  var overlay=document.querySelector('[data-menu-overlay]');
  var closeBtn=document.querySelector('[data-menu-close]');
  if(!trigger||!drawer||!overlay)return;
  function open(){drawer.classList.add('open');overlay.classList.add('open');overlay.removeAttribute('hidden');trigger.setAttribute('aria-expanded','true');drawer.setAttribute('aria-hidden','false');document.documentElement.classList.add('lvh-menu-open');}
  function shut(){drawer.classList.remove('open');overlay.classList.remove('open');trigger.setAttribute('aria-expanded','false');drawer.setAttribute('aria-hidden','true');document.documentElement.classList.remove('lvh-menu-open');setTimeout(function(){overlay.setAttribute('hidden','');},300);}
  trigger.addEventListener('click',open);
  if(closeBtn)closeBtn.addEventListener('click',shut);
  overlay.addEventListener('click',shut);
  document.addEventListener('keydown',function(e){if(e.key==='Escape'&&drawer.classList.contains('open'))shut();});
})();
(function(){
  var form=document.getElementById('lvBuyForm');
  if(!form)return;
  var status=document.getElementById('lvCartStatus');
  var cta=document.getElementById('lvCta');
  var nativeFallback=false;
  form.addEventListener('submit',function(e){
    if(nativeFallback)return;
    e.preventDefault();
    if(cta)cta.disabled=true;
    if(status){status.hidden=false;status.textContent='Adding to cart…';}
    var fd=new FormData(form);
    fetch('/cart/clear.js',{method:'POST',headers:{'Accept':'application/json'}})
      .then(function(){return fetch('/cart/add.js',{method:'POST',body:fd,headers:{'Accept':'application/json'}});})
      .then(function(res){
        if(!res.ok){throw new Error('add failed');}
        if(status){status.textContent='Added! Redirecting…';}
        window.location.href='/checkout';
      })
      .catch(function(){
        if(status){status.textContent='Finishing in cart…';}
        nativeFallback=true;
        form.submit();
      });
  });
})();
(function(){
  document.querySelectorAll('.lv-tcard--video').forEach(function(card){
    var btn=card.querySelector('.lv-ugc-play');
    if(!btn)return;
    btn.addEventListener('click',function(){
      if(card.classList.contains('is-playing'))return;
      var src=card.getAttribute('data-video'); if(!src)return;
      document.querySelectorAll('.lv-tcard--video video').forEach(function(v){v.pause();});
      var v=document.createElement('video');
      v.className='lv-ugc-video'; v.src=src; v.controls=true; v.setAttribute('playsinline','');
      var p=card.querySelector('.lv-ugc-poster'); if(p)p.style.display='none';
      card.appendChild(v); card.classList.add('is-playing'); v.play();
    });
  });
  var row=document.getElementById('lvTestiRow');
  if(row){
    var prev=document.querySelector('[data-testi-prev]');
    var next=document.querySelector('[data-testi-next]');
    function step(d){row.scrollBy({left:d*280,behavior:'smooth'});}
    if(prev)prev.addEventListener('click',function(){step(-1);});
    if(next)next.addEventListener('click',function(){step(1);});
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["livera-lp-men-fatigue"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.lv').forEach(function(root){
  var main=root.querySelector('#lvGalMain');
  var lvVid=root.querySelector('#lvGalVideo');
  root.querySelectorAll('.lv-thumb').forEach(function(t){
    t.addEventListener('click',function(){
      root.querySelectorAll('.lv-thumb').forEach(function(x){x.classList.remove('is-active')});
      t.classList.add('is-active');
      if(t.dataset.type==='video' && lvVid){
        if(main) main.style.display='none';
        lvVid.style.display='block';
        var s=lvVid.querySelector('source');
        if(s && s.getAttribute('src')!==t.dataset.src){ s.src=t.dataset.src; lvVid.load(); }
        var pp=lvVid.play(); if(pp&&pp.catch) pp.catch(function(){});
      } else {
        if(lvVid){ lvVid.pause(); lvVid.style.display='none'; }
        if(main){ main.style.display='block'; if(t.dataset.src) main.src=t.dataset.src; }
      }
    });
  });
  var lvStage = root.querySelector('.lv-gallery-main');
  if (lvStage) {
    var lsx=0, lsy=0, ltk=false;
    lvStage.addEventListener('touchstart', function(e){ var t=e.changedTouches[0]; lsx=t.clientX; lsy=t.clientY; ltk=true; }, {passive:true});
    lvStage.addEventListener('touchend', function(e){ if(!ltk)return; ltk=false; var t=e.changedTouches[0]; var dx=t.clientX-lsx, dy=t.clientY-lsy; if(Math.abs(dx)>40 && Math.abs(dx)>Math.abs(dy)){ var th=root.querySelectorAll('.lv-thumb'); var cur=0; th.forEach(function(x,i){ if(x.classList.contains('is-active')) cur=i; }); var nx=(cur+(dx<0?1:-1)+th.length)%th.length; th[nx].click(); } }, {passive:true});
  }
  root.querySelectorAll('.lv-offer').forEach(function(o){
    o.addEventListener('click',function(){
      root.querySelectorAll('.lv-offer').forEach(function(x){x.classList.remove('is-selected');var r=x.querySelector('input[type=radio]');if(r)r.checked=false;});
      o.classList.add('is-selected');var r=o.querySelector('input[type=radio]');if(r)r.checked=true;
      var vi=document.getElementById('lvVarInput'),qi=document.getElementById('lvQtyInput'),pi=document.getElementById('lvPlanInput');
      if(vi)vi.value=o.getAttribute('data-variant')||'';
      if(qi)qi.value=o.getAttribute('data-qty')||'1';
      if(pi){var p=o.getAttribute('data-plan')||'';if(p){pi.value=p;pi.disabled=false;}else{pi.value='';pi.disabled=true;}}
    });
  });
});
(function(){
  var trigger=document.querySelector('[data-menu-trigger]');
  var drawer=document.querySelector('[data-menu-drawer]');
  var overlay=document.querySelector('[data-menu-overlay]');
  var closeBtn=document.querySelector('[data-menu-close]');
  if(!trigger||!drawer||!overlay)return;
  function open(){drawer.classList.add('open');overlay.classList.add('open');overlay.removeAttribute('hidden');trigger.setAttribute('aria-expanded','true');drawer.setAttribute('aria-hidden','false');document.documentElement.classList.add('lvh-menu-open');}
  function shut(){drawer.classList.remove('open');overlay.classList.remove('open');trigger.setAttribute('aria-expanded','false');drawer.setAttribute('aria-hidden','true');document.documentElement.classList.remove('lvh-menu-open');setTimeout(function(){overlay.setAttribute('hidden','');},300);}
  trigger.addEventListener('click',open);
  if(closeBtn)closeBtn.addEventListener('click',shut);
  overlay.addEventListener('click',shut);
  document.addEventListener('keydown',function(e){if(e.key==='Escape'&&drawer.classList.contains('open'))shut();});
})();
(function(){
  var form=document.getElementById('lvBuyForm');
  if(!form)return;
  var status=document.getElementById('lvCartStatus');
  var cta=document.getElementById('lvCta');
  var nativeFallback=false;
  form.addEventListener('submit',function(e){
    if(nativeFallback)return;
    e.preventDefault();
    if(cta)cta.disabled=true;
    if(status){status.hidden=false;status.textContent='Adding to cart…';}
    var fd=new FormData(form);
    fetch('/cart/clear.js',{method:'POST',headers:{'Accept':'application/json'}})
      .then(function(){return fetch('/cart/add.js',{method:'POST',body:fd,headers:{'Accept':'application/json'}});})
      .then(function(res){
        if(!res.ok){throw new Error('add failed');}
        if(status){status.textContent='Added! Redirecting…';}
        window.location.href='/checkout';
      })
      .catch(function(){
        if(status){status.textContent='Finishing in cart…';}
        nativeFallback=true;
        form.submit();
      });
  });
})();
(function(){
  document.querySelectorAll('.lv-tcard--video').forEach(function(card){
    var btn=card.querySelector('.lv-ugc-play');
    if(!btn)return;
    btn.addEventListener('click',function(){
      if(card.classList.contains('is-playing'))return;
      var src=card.getAttribute('data-video'); if(!src)return;
      document.querySelectorAll('.lv-tcard--video video').forEach(function(v){v.pause();});
      var v=document.createElement('video');
      v.className='lv-ugc-video'; v.src=src; v.controls=true; v.setAttribute('playsinline','');
      var p=card.querySelector('.lv-ugc-poster'); if(p)p.style.display='none';
      card.appendChild(v); card.classList.add('is-playing'); v.play();
    });
  });
  var row=document.getElementById('lvTestiRow');
  if(row){
    var prev=document.querySelector('[data-testi-prev]');
    var next=document.querySelector('[data-testi-next]');
    function step(d){row.scrollBy({left:d*280,behavior:'smooth'});}
    if(prev)prev.addEventListener('click',function(){step(-1);});
    if(next)next.addEventListener('click',function(){step(1);});
    var down=false,startX=0,startScroll=0,moved=false;
    row.style.cursor='grab';
    row.addEventListener('pointerdown',function(e){if(e.pointerType!=='mouse')return;down=true;moved=false;startX=e.clientX;startScroll=row.scrollLeft;row.setPointerCapture(e.pointerId);row.style.cursor='grabbing';});
    row.addEventListener('pointermove',function(e){if(!down)return;var dx=e.clientX-startX;if(Math.abs(dx)>4)moved=true;row.scrollLeft=startScroll-dx;});
    function endDrag(){if(down){down=false;row.style.cursor='grab';}}
    row.addEventListener('pointerup',endDrag);
    row.addEventListener('pointercancel',endDrag);
    row.addEventListener('click',function(e){if(moved){e.preventDefault();e.stopPropagation();moved=false;}},true);
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["livera-lp-not-a-quickfix"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.lv').forEach(function(root){
  var main=root.querySelector('#lvGalMain');
  var lvVid=root.querySelector('#lvGalVideo');
  root.querySelectorAll('.lv-thumb').forEach(function(t){
    t.addEventListener('click',function(){
      root.querySelectorAll('.lv-thumb').forEach(function(x){x.classList.remove('is-active')});
      t.classList.add('is-active');
      if(t.dataset.type==='video' && lvVid){
        if(main) main.style.display='none';
        lvVid.style.display='block';
        var s=lvVid.querySelector('source');
        if(s && s.getAttribute('src')!==t.dataset.src){ s.src=t.dataset.src; lvVid.load(); }
        var pp=lvVid.play(); if(pp&&pp.catch) pp.catch(function(){});
      } else {
        if(lvVid){ lvVid.pause(); lvVid.style.display='none'; }
        if(main){ main.style.display='block'; if(t.dataset.src) main.src=t.dataset.src; }
      }
    });
  });
  var lvStage = root.querySelector('.lv-gallery-main');
  if (lvStage) {
    var lsx=0, lsy=0, ltk=false;
    lvStage.addEventListener('touchstart', function(e){ var t=e.changedTouches[0]; lsx=t.clientX; lsy=t.clientY; ltk=true; }, {passive:true});
    lvStage.addEventListener('touchend', function(e){ if(!ltk)return; ltk=false; var t=e.changedTouches[0]; var dx=t.clientX-lsx, dy=t.clientY-lsy; if(Math.abs(dx)>40 && Math.abs(dx)>Math.abs(dy)){ var th=root.querySelectorAll('.lv-thumb'); var cur=0; th.forEach(function(x,i){ if(x.classList.contains('is-active')) cur=i; }); var nx=(cur+(dx<0?1:-1)+th.length)%th.length; th[nx].click(); } }, {passive:true});
  }
  root.querySelectorAll('.lv-offer').forEach(function(o){
    o.addEventListener('click',function(){
      root.querySelectorAll('.lv-offer').forEach(function(x){x.classList.remove('is-selected');var r=x.querySelector('input[type=radio]');if(r)r.checked=false;});
      o.classList.add('is-selected');var r=o.querySelector('input[type=radio]');if(r)r.checked=true;
      var vi=document.getElementById('lvVarInput'),qi=document.getElementById('lvQtyInput'),pi=document.getElementById('lvPlanInput');
      if(vi)vi.value=o.getAttribute('data-variant')||'';
      if(qi)qi.value=o.getAttribute('data-qty')||'1';
      if(pi){var p=o.getAttribute('data-plan')||'';if(p){pi.value=p;pi.disabled=false;}else{pi.value='';pi.disabled=true;}}
    });
  });
});
(function(){
  var trigger=document.querySelector('[data-menu-trigger]');
  var drawer=document.querySelector('[data-menu-drawer]');
  var overlay=document.querySelector('[data-menu-overlay]');
  var closeBtn=document.querySelector('[data-menu-close]');
  if(!trigger||!drawer||!overlay)return;
  function open(){drawer.classList.add('open');overlay.classList.add('open');overlay.removeAttribute('hidden');trigger.setAttribute('aria-expanded','true');drawer.setAttribute('aria-hidden','false');document.documentElement.classList.add('lvh-menu-open');}
  function shut(){drawer.classList.remove('open');overlay.classList.remove('open');trigger.setAttribute('aria-expanded','false');drawer.setAttribute('aria-hidden','true');document.documentElement.classList.remove('lvh-menu-open');setTimeout(function(){overlay.setAttribute('hidden','');},300);}
  trigger.addEventListener('click',open);
  if(closeBtn)closeBtn.addEventListener('click',shut);
  overlay.addEventListener('click',shut);
  document.addEventListener('keydown',function(e){if(e.key==='Escape'&&drawer.classList.contains('open'))shut();});
})();
(function(){
  var form=document.getElementById('lvBuyForm');
  if(!form)return;
  var status=document.getElementById('lvCartStatus');
  var cta=document.getElementById('lvCta');
  var nativeFallback=false;
  form.addEventListener('submit',function(e){
    if(nativeFallback)return;
    e.preventDefault();
    if(cta)cta.disabled=true;
    if(status){status.hidden=false;status.textContent='Adding to cart…';}
    var fd=new FormData(form);
    fetch('/cart/clear.js',{method:'POST',headers:{'Accept':'application/json'}})
      .then(function(){return fetch('/cart/add.js',{method:'POST',body:fd,headers:{'Accept':'application/json'}});})
      .then(function(res){
        if(!res.ok){throw new Error('add failed');}
        if(status){status.textContent='Added! Redirecting…';}
        window.location.href='/checkout';
      })
      .catch(function(){
        if(status){status.textContent='Finishing in cart…';}
        nativeFallback=true;
        form.submit();
      });
  });
})();
(function(){
  document.querySelectorAll('.lv-tcard--video').forEach(function(card){
    var btn=card.querySelector('.lv-ugc-play');
    if(!btn)return;
    btn.addEventListener('click',function(){
      if(card.classList.contains('is-playing'))return;
      var src=card.getAttribute('data-video'); if(!src)return;
      document.querySelectorAll('.lv-tcard--video video').forEach(function(v){v.pause();});
      var v=document.createElement('video');
      v.className='lv-ugc-video'; v.src=src; v.controls=true; v.setAttribute('playsinline','');
      var p=card.querySelector('.lv-ugc-poster'); if(p)p.style.display='none';
      card.appendChild(v); card.classList.add('is-playing'); v.play();
    });
  });
  var row=document.getElementById('lvTestiRow');
  if(row){
    var prev=document.querySelector('[data-testi-prev]');
    var next=document.querySelector('[data-testi-next]');
    function step(d){row.scrollBy({left:d*280,behavior:'smooth'});}
    if(prev)prev.addEventListener('click',function(){step(-1);});
    if(next)next.addEventListener('click',function(){step(1);});
    var down=false,startX=0,startScroll=0,moved=false;
    row.style.cursor='grab';
    row.addEventListener('pointerdown',function(e){if(e.pointerType!=='mouse')return;down=true;moved=false;startX=e.clientX;startScroll=row.scrollLeft;row.setPointerCapture(e.pointerId);row.style.cursor='grabbing';});
    row.addEventListener('pointermove',function(e){if(!down)return;var dx=e.clientX-startX;if(Math.abs(dx)>4)moved=true;row.scrollLeft=startScroll-dx;});
    function endDrag(){if(down){down=false;row.style.cursor='grab';}}
    row.addEventListener('pointerup',endDrag);
    row.addEventListener('pointercancel',endDrag);
    row.addEventListener('click',function(e){if(moved){e.preventDefault();e.stopPropagation();moved=false;}},true);
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["livera-lp-not-t-stacks"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.lv').forEach(function(root){
  var main=root.querySelector('#lvGalMain');
  var lvVid=root.querySelector('#lvGalVideo');
  root.querySelectorAll('.lv-thumb').forEach(function(t){
    t.addEventListener('click',function(){
      root.querySelectorAll('.lv-thumb').forEach(function(x){x.classList.remove('is-active')});
      t.classList.add('is-active');
      if(t.dataset.type==='video' && lvVid){
        if(main) main.style.display='none';
        lvVid.style.display='block';
        var s=lvVid.querySelector('source');
        if(s && s.getAttribute('src')!==t.dataset.src){ s.src=t.dataset.src; lvVid.load(); }
        var pp=lvVid.play(); if(pp&&pp.catch) pp.catch(function(){});
      } else {
        if(lvVid){ lvVid.pause(); lvVid.style.display='none'; }
        if(main){ main.style.display='block'; if(t.dataset.src) main.src=t.dataset.src; }
      }
    });
  });
  var lvStage = root.querySelector('.lv-gallery-main');
  if (lvStage) {
    var lsx=0, lsy=0, ltk=false;
    lvStage.addEventListener('touchstart', function(e){ var t=e.changedTouches[0]; lsx=t.clientX; lsy=t.clientY; ltk=true; }, {passive:true});
    lvStage.addEventListener('touchend', function(e){ if(!ltk)return; ltk=false; var t=e.changedTouches[0]; var dx=t.clientX-lsx, dy=t.clientY-lsy; if(Math.abs(dx)>40 && Math.abs(dx)>Math.abs(dy)){ var th=root.querySelectorAll('.lv-thumb'); var cur=0; th.forEach(function(x,i){ if(x.classList.contains('is-active')) cur=i; }); var nx=(cur+(dx<0?1:-1)+th.length)%th.length; th[nx].click(); } }, {passive:true});
  }
  root.querySelectorAll('.lv-offer').forEach(function(o){
    o.addEventListener('click',function(){
      root.querySelectorAll('.lv-offer').forEach(function(x){x.classList.remove('is-selected');var r=x.querySelector('input[type=radio]');if(r)r.checked=false;});
      o.classList.add('is-selected');var r=o.querySelector('input[type=radio]');if(r)r.checked=true;
      var vi=document.getElementById('lvVarInput'),qi=document.getElementById('lvQtyInput'),pi=document.getElementById('lvPlanInput');
      if(vi)vi.value=o.getAttribute('data-variant')||'';
      if(qi)qi.value=o.getAttribute('data-qty')||'1';
      if(pi){var p=o.getAttribute('data-plan')||'';if(p){pi.value=p;pi.disabled=false;}else{pi.value='';pi.disabled=true;}}
    });
  });
});
(function(){
  var trigger=document.querySelector('[data-menu-trigger]');
  var drawer=document.querySelector('[data-menu-drawer]');
  var overlay=document.querySelector('[data-menu-overlay]');
  var closeBtn=document.querySelector('[data-menu-close]');
  if(!trigger||!drawer||!overlay)return;
  function open(){drawer.classList.add('open');overlay.classList.add('open');overlay.removeAttribute('hidden');trigger.setAttribute('aria-expanded','true');drawer.setAttribute('aria-hidden','false');document.documentElement.classList.add('lvh-menu-open');}
  function shut(){drawer.classList.remove('open');overlay.classList.remove('open');trigger.setAttribute('aria-expanded','false');drawer.setAttribute('aria-hidden','true');document.documentElement.classList.remove('lvh-menu-open');setTimeout(function(){overlay.setAttribute('hidden','');},300);}
  trigger.addEventListener('click',open);
  if(closeBtn)closeBtn.addEventListener('click',shut);
  overlay.addEventListener('click',shut);
  document.addEventListener('keydown',function(e){if(e.key==='Escape'&&drawer.classList.contains('open'))shut();});
})();
(function(){
  var form=document.getElementById('lvBuyForm');
  if(!form)return;
  var status=document.getElementById('lvCartStatus');
  var cta=document.getElementById('lvCta');
  var nativeFallback=false;
  form.addEventListener('submit',function(e){
    if(nativeFallback)return;
    e.preventDefault();
    if(cta)cta.disabled=true;
    if(status){status.hidden=false;status.textContent='Adding to cart…';}
    var fd=new FormData(form);
    fetch('/cart/clear.js',{method:'POST',headers:{'Accept':'application/json'}})
      .then(function(){return fetch('/cart/add.js',{method:'POST',body:fd,headers:{'Accept':'application/json'}});})
      .then(function(res){
        if(!res.ok){throw new Error('add failed');}
        if(status){status.textContent='Added! Redirecting…';}
        window.location.href='/checkout';
      })
      .catch(function(){
        if(status){status.textContent='Finishing in cart…';}
        nativeFallback=true;
        form.submit();
      });
  });
})();
(function(){
  document.querySelectorAll('.lv-tcard--video').forEach(function(card){
    var btn=card.querySelector('.lv-ugc-play');
    if(!btn)return;
    btn.addEventListener('click',function(){
      if(card.classList.contains('is-playing'))return;
      var src=card.getAttribute('data-video'); if(!src)return;
      document.querySelectorAll('.lv-tcard--video video').forEach(function(v){v.pause();});
      var v=document.createElement('video');
      v.className='lv-ugc-video'; v.src=src; v.controls=true; v.setAttribute('playsinline','');
      var p=card.querySelector('.lv-ugc-poster'); if(p)p.style.display='none';
      card.appendChild(v); card.classList.add('is-playing'); v.play();
    });
  });
  var row=document.getElementById('lvTestiRow');
  if(row){
    var prev=document.querySelector('[data-testi-prev]');
    var next=document.querySelector('[data-testi-next]');
    function step(d){row.scrollBy({left:d*280,behavior:'smooth'});}
    if(prev)prev.addEventListener('click',function(){step(-1);});
    if(next)next.addEventListener('click',function(){step(1);});
    var down=false,startX=0,startScroll=0,moved=false;
    row.style.cursor='grab';
    row.addEventListener('pointerdown',function(e){if(e.pointerType!=='mouse')return;down=true;moved=false;startX=e.clientX;startScroll=row.scrollLeft;row.setPointerCapture(e.pointerId);row.style.cursor='grabbing';});
    row.addEventListener('pointermove',function(e){if(!down)return;var dx=e.clientX-startX;if(Math.abs(dx)>4)moved=true;row.scrollLeft=startScroll-dx;});
    function endDrag(){if(down){down=false;row.style.cursor='grab';}}
    row.addEventListener('pointerup',endDrag);
    row.addEventListener('pointercancel',endDrag);
    row.addEventListener('click',function(e){if(moved){e.preventDefault();e.stopPropagation();moved=false;}},true);
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["livera-lp-resilia"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.lv').forEach(function(root){
  var main=root.querySelector('#lvGalMain');
  var lvVid=root.querySelector('#lvGalVideo');
  root.querySelectorAll('.lv-thumb').forEach(function(t){
    t.addEventListener('click',function(){
      root.querySelectorAll('.lv-thumb').forEach(function(x){x.classList.remove('is-active')});
      t.classList.add('is-active');
      if(t.dataset.type==='video' && lvVid){
        if(main) main.style.display='none';
        lvVid.style.display='block';
        var s=lvVid.querySelector('source');
        if(s && s.getAttribute('src')!==t.dataset.src){ s.src=t.dataset.src; lvVid.load(); }
        var pp=lvVid.play(); if(pp&&pp.catch) pp.catch(function(){});
      } else {
        if(lvVid){ lvVid.pause(); lvVid.style.display='none'; }
        if(main){ main.style.display='block'; if(t.dataset.src) main.src=t.dataset.src; }
      }
    });
  });
  var lvStage = root.querySelector('.lv-gallery-main');
  if (lvStage) {
    var lsx=0, lsy=0, ltk=false;
    lvStage.addEventListener('touchstart', function(e){ var t=e.changedTouches[0]; lsx=t.clientX; lsy=t.clientY; ltk=true; }, {passive:true});
    lvStage.addEventListener('touchend', function(e){ if(!ltk)return; ltk=false; var t=e.changedTouches[0]; var dx=t.clientX-lsx, dy=t.clientY-lsy; if(Math.abs(dx)>40 && Math.abs(dx)>Math.abs(dy)){ var th=root.querySelectorAll('.lv-thumb'); var cur=0; th.forEach(function(x,i){ if(x.classList.contains('is-active')) cur=i; }); var nx=(cur+(dx<0?1:-1)+th.length)%th.length; th[nx].click(); } }, {passive:true});
  }
  root.querySelectorAll('.lv-offer').forEach(function(o){
    o.addEventListener('click',function(){
      root.querySelectorAll('.lv-offer').forEach(function(x){x.classList.remove('is-selected');var r=x.querySelector('input[type=radio]');if(r)r.checked=false;});
      o.classList.add('is-selected');var r=o.querySelector('input[type=radio]');if(r)r.checked=true;
      var vi=document.getElementById('lvVarInput'),qi=document.getElementById('lvQtyInput'),pi=document.getElementById('lvPlanInput');
      if(vi)vi.value=o.getAttribute('data-variant')||'';
      if(qi)qi.value=o.getAttribute('data-qty')||'1';
      if(pi){var p=o.getAttribute('data-plan')||'';if(p){pi.value=p;pi.disabled=false;}else{pi.value='';pi.disabled=true;}}
    });
  });
});
(function(){
  var trigger=document.querySelector('[data-menu-trigger]');
  var drawer=document.querySelector('[data-menu-drawer]');
  var overlay=document.querySelector('[data-menu-overlay]');
  var closeBtn=document.querySelector('[data-menu-close]');
  if(!trigger||!drawer||!overlay)return;
  function open(){drawer.classList.add('open');overlay.classList.add('open');overlay.removeAttribute('hidden');trigger.setAttribute('aria-expanded','true');drawer.setAttribute('aria-hidden','false');document.documentElement.classList.add('lvh-menu-open');}
  function shut(){drawer.classList.remove('open');overlay.classList.remove('open');trigger.setAttribute('aria-expanded','false');drawer.setAttribute('aria-hidden','true');document.documentElement.classList.remove('lvh-menu-open');setTimeout(function(){overlay.setAttribute('hidden','');},300);}
  trigger.addEventListener('click',open);
  if(closeBtn)closeBtn.addEventListener('click',shut);
  overlay.addEventListener('click',shut);
  document.addEventListener('keydown',function(e){if(e.key==='Escape'&&drawer.classList.contains('open'))shut();});
})();
(function(){
  var form=document.getElementById('lvBuyForm');
  if(!form)return;
  var status=document.getElementById('lvCartStatus');
  var cta=document.getElementById('lvCta');
  var nativeFallback=false;
  form.addEventListener('submit',function(e){
    if(nativeFallback)return;
    e.preventDefault();
    if(cta)cta.disabled=true;
    if(status){status.hidden=false;status.textContent='Adding to cart…';}
    var fd=new FormData(form);
    fetch('/cart/clear.js',{method:'POST',headers:{'Accept':'application/json'}})
      .then(function(){return fetch('/cart/add.js',{method:'POST',body:fd,headers:{'Accept':'application/json'}});})
      .then(function(res){
        if(!res.ok){throw new Error('add failed');}
        if(status){status.textContent='Added! Redirecting…';}
        window.location.href='/checkout';
      })
      .catch(function(){
        if(status){status.textContent='Finishing in cart…';}
        nativeFallback=true;
        form.submit();
      });
  });
})();
(function(){
  document.querySelectorAll('.lv-tcard--video').forEach(function(card){
    var btn=card.querySelector('.lv-ugc-play');
    if(!btn)return;
    btn.addEventListener('click',function(){
      if(card.classList.contains('is-playing'))return;
      var src=card.getAttribute('data-video'); if(!src)return;
      document.querySelectorAll('.lv-tcard--video video').forEach(function(v){v.pause();});
      var v=document.createElement('video');
      v.className='lv-ugc-video'; v.src=src; v.controls=true; v.setAttribute('playsinline','');
      var p=card.querySelector('.lv-ugc-poster'); if(p)p.style.display='none';
      card.appendChild(v); card.classList.add('is-playing'); v.play();
    });
  });
  var row=document.getElementById('lvTestiRow');
  if(row){
    var prev=document.querySelector('[data-testi-prev]');
    var next=document.querySelector('[data-testi-next]');
    function step(d){row.scrollBy({left:d*280,behavior:'smooth'});}
    if(prev)prev.addEventListener('click',function(){step(-1);});
    if(next)next.addEventListener('click',function(){step(1);});
  }
})();

// resilia-style rolling sale countdown (to local midnight)
(function(){
  var el = document.getElementById('lvresTimer');
  if (!el) return;
  function tick(){
    var now = new Date();
    var end = new Date(now); end.setHours(24,0,0,0);
    var d = Math.max(0, end - now);
    var h = String(Math.floor(d/3600000)).padStart(2,'0');
    var m = String(Math.floor(d%3600000/60000)).padStart(2,'0');
    var sec = String(Math.floor(d%60000/1000)).padStart(2,'0');
    el.textContent = h + ':' + m + ':' + sec;
  }
  tick(); setInterval(tick, 1000);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["livera-lp"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.lv').forEach(function(root){
  var main=root.querySelector('#lvGalMain');
  var lvVid=root.querySelector('#lvGalVideo');
  root.querySelectorAll('.lv-thumb').forEach(function(t){
    t.addEventListener('click',function(){
      root.querySelectorAll('.lv-thumb').forEach(function(x){x.classList.remove('is-active')});
      t.classList.add('is-active');
      if(t.dataset.type==='video' && lvVid){
        if(main) main.style.display='none';
        lvVid.style.display='block';
        var s=lvVid.querySelector('source');
        if(s && s.getAttribute('src')!==t.dataset.src){ s.src=t.dataset.src; lvVid.load(); }
        var pp=lvVid.play(); if(pp&&pp.catch) pp.catch(function(){});
      } else {
        if(lvVid){ lvVid.pause(); lvVid.style.display='none'; }
        if(main){ main.style.display='block'; if(t.dataset.src) main.src=t.dataset.src; }
      }
    });
  });
  var lvStage = root.querySelector('.lv-gallery-main');
  if (lvStage) {
    var lsx=0, lsy=0, ltk=false;
    lvStage.addEventListener('touchstart', function(e){ var t=e.changedTouches[0]; lsx=t.clientX; lsy=t.clientY; ltk=true; }, {passive:true});
    lvStage.addEventListener('touchend', function(e){ if(!ltk)return; ltk=false; var t=e.changedTouches[0]; var dx=t.clientX-lsx, dy=t.clientY-lsy; if(Math.abs(dx)>40 && Math.abs(dx)>Math.abs(dy)){ var th=root.querySelectorAll('.lv-thumb'); var cur=0; th.forEach(function(x,i){ if(x.classList.contains('is-active')) cur=i; }); var nx=(cur+(dx<0?1:-1)+th.length)%th.length; th[nx].click(); } }, {passive:true});
  }
  root.querySelectorAll('.lv-offer').forEach(function(o){
    o.addEventListener('click',function(){
      root.querySelectorAll('.lv-offer').forEach(function(x){x.classList.remove('is-selected');var r=x.querySelector('input[type=radio]');if(r)r.checked=false;});
      o.classList.add('is-selected');var r=o.querySelector('input[type=radio]');if(r)r.checked=true;
      var vi=document.getElementById('lvVarInput'),qi=document.getElementById('lvQtyInput'),pi=document.getElementById('lvPlanInput');
      if(vi)vi.value=o.getAttribute('data-variant')||'';
      if(qi)qi.value=o.getAttribute('data-qty')||'1';
      if(pi){var p=o.getAttribute('data-plan')||'';if(p){pi.value=p;pi.disabled=false;}else{pi.value='';pi.disabled=true;}}
    });
  });
});
(function(){
  var trigger=document.querySelector('[data-menu-trigger]');
  var drawer=document.querySelector('[data-menu-drawer]');
  var overlay=document.querySelector('[data-menu-overlay]');
  var closeBtn=document.querySelector('[data-menu-close]');
  if(!trigger||!drawer||!overlay)return;
  function open(){drawer.classList.add('open');overlay.classList.add('open');overlay.removeAttribute('hidden');trigger.setAttribute('aria-expanded','true');drawer.setAttribute('aria-hidden','false');document.documentElement.classList.add('lvh-menu-open');}
  function shut(){drawer.classList.remove('open');overlay.classList.remove('open');trigger.setAttribute('aria-expanded','false');drawer.setAttribute('aria-hidden','true');document.documentElement.classList.remove('lvh-menu-open');setTimeout(function(){overlay.setAttribute('hidden','');},300);}
  trigger.addEventListener('click',open);
  if(closeBtn)closeBtn.addEventListener('click',shut);
  overlay.addEventListener('click',shut);
  document.addEventListener('keydown',function(e){if(e.key==='Escape'&&drawer.classList.contains('open'))shut();});
})();
(function(){
  var form=document.getElementById('lvBuyForm');
  if(!form)return;
  var status=document.getElementById('lvCartStatus');
  var cta=document.getElementById('lvCta');
  var nativeFallback=false;
  form.addEventListener('submit',function(e){
    if(nativeFallback)return;
    e.preventDefault();
    if(cta)cta.disabled=true;
    if(status){status.hidden=false;status.textContent='Adding to cart…';}
    var fd=new FormData(form);
    fetch('/cart/clear.js',{method:'POST',headers:{'Accept':'application/json'}})
      .then(function(){return fetch('/cart/add.js',{method:'POST',body:fd,headers:{'Accept':'application/json'}});})
      .then(function(res){
        if(!res.ok){throw new Error('add failed');}
        if(status){status.textContent='Added! Redirecting…';}
        window.location.href='/checkout';
      })
      .catch(function(){
        if(status){status.textContent='Finishing in cart…';}
        nativeFallback=true;
        form.submit();
      });
  });
})();
(function(){
  document.querySelectorAll('.lv-tcard--video').forEach(function(card){
    var btn=card.querySelector('.lv-ugc-play');
    if(!btn)return;
    btn.addEventListener('click',function(){
      if(card.classList.contains('is-playing'))return;
      var src=card.getAttribute('data-video'); if(!src)return;
      document.querySelectorAll('.lv-tcard--video video').forEach(function(v){v.pause();});
      var v=document.createElement('video');
      v.className='lv-ugc-video'; v.src=src; v.controls=true; v.setAttribute('playsinline','');
      var p=card.querySelector('.lv-ugc-poster'); if(p)p.style.display='none';
      card.appendChild(v); card.classList.add('is-playing'); v.play();
    });
  });
  var row=document.getElementById('lvTestiRow');
  if(row){
    var prev=document.querySelector('[data-testi-prev]');
    var next=document.querySelector('[data-testi-next]');
    function step(d){row.scrollBy({left:d*280,behavior:'smooth'});}
    if(prev)prev.addEventListener('click',function(){step(-1);});
    if(next)next.addEventListener('click',function(){step(1);});
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
